"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatedApiKeyImpulse = void 0;
var CreatedApiKey_1 = require("./CreatedApiKey");
/**
 * Impulse which indicates the result of a create api key impulse
 */
var CreatedApiKeyImpulse = /** @class */ (function (_super) {
    __extends(CreatedApiKeyImpulse, _super);
    function CreatedApiKeyImpulse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "CreatedApiKeyImpulse";
        _this.id = function () {
            _this.push(function (_) { return "id"; });
        };
        _this.data = function (config) { return _this.push(function (registry) {
            var entity = new CreatedApiKey_1.CreatedApiKey();
            config(entity);
            return "data { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return CreatedApiKeyImpulse;
}(Array));
exports.CreatedApiKeyImpulse = CreatedApiKeyImpulse;
//# sourceMappingURL=CreatedApiKeyImpulse.js.map